import { EducateType } from '@/types/educate';
import type { EducateModule } from '@/hooks/useEducateModule';
import { ErrorScreen } from '@/components/StatusScreens';
import { ConceptWalkthroughHost } from './products/conceptWalkthrough';
import { ScenarioLedHost } from './products/scenarioLed';
import { CaseStudyHost } from './products/caseStudy';
import { DecisionTreeHost } from './products/decisionTree';
import { DiagnosticHost } from './products/diagnostic';
import { AudiobookHost } from './products/audiobook';
import { PodcastHost } from './products/podcast';

export function ModuleRouterV2({ module }: { module: EducateModule }) {
  switch (module.storyline?.educateType) {
    case EducateType.CONCEPT_WALKTHROUGH:
      return <ConceptWalkthroughHost module={module} />;
    case EducateType.SCENARIO_LED:
      return <ScenarioLedHost module={module} />;
    case EducateType.DECISION_TREE:
      return <DecisionTreeHost module={module} />;
    case EducateType.CASE_STUDY:
      return <CaseStudyHost module={module} />;
    case EducateType.DIAGNOSTIC:
      return <DiagnosticHost module={module} />;
    case EducateType.AUDIOBOOK:
      return <AudiobookHost module={module} />;
    case EducateType.PODCAST:
      return <PodcastHost module={module} />;
    default:
      return (
        <div className="w-full px-[18%] py-12">
          <ErrorScreen
            message={`This module's format (${module.storyline?.educateType}) cannot be displayed yet.`}
          />
        </div>
      );
  }
}
